<div class="login-container">
  <div class="login-card">
    <app-header></app-header>

    <div *ngIf="!(isAuthenticated$ | async)">

      <div class="social-logins" *ngIf="showSocialLogin">
        <button
          (click)="signInWithProvider('google')"
          class="social-btn"
          *ngIf="showGoogleLogin"
        >
          <img src="assets/google-icon.svg" alt="Google" />
          <span class="social-login-text">Sign in with Google</span>
        </button>
        <button
          (click)="signInWithProvider('apple')"
          class="social-btn"
          *ngIf="showAppleLogin"
        >
          <img src="assets/apple-icon.svg" alt="Apple" />
          <span class="social-login-text">Apple</span>
        </button>
        <button
          (click)="signInWithProvider('facebook')"
          class="social-btn"
          *ngIf="showFacebookLogin"
        >
          <img src="assets/facebook-icon.svg" alt="Facebook" />
          <span class="social-login-text">Facebook</span>
        </button>
      </div>

      <div class="divider">
        <span>or</span>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="on">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Enter your email"
            autocomplete="email"
          />
        </div>

        <div class="form-group password-group">
          <div class="label-and-link">
            <label for="password">Password</label>
            <a
              href="/forgot-password"
              tabindex="-1"
              *ngIf="showForgotPassword"
              class="forgot-password"
              >Forgot password?</a
            >
          </div>
          <div class="password-input">
            <input
              id="current-password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="••••••••"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="toggle-password"
              tabindex="-1"
              (click)="togglePasswordVisibility()"
            >
              <img
                [src]="
                  showPassword
                    ? 'assets/eye-off-icon.svg'
                    : 'assets/eye-icon.svg'
                "
                alt="Toggle password"
              />
            </button>
          </div>
        </div>

        <div class="form-footer">
          <button
            type="submit"
            class="sign-in-btn"
            [disabled]="loginForm.invalid || isLoading"
          >
            {{ isLoading ? 'Signing in...' : 'Sign in' }}
          </button>
        </div>

        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
      </form>

      <p class="create-account" *ngIf="allowCreateAccount">
        Don't have an account? <a href="/signup">Create account</a>
      </p>
    </div>
  </div>
</div>
